module.exports = __webpack_public_path__ + "img/crown.adc0fc3e.svg";